import { DataModel } from "common/models/utility-models/base-model";

export class GroupDetailModel extends DataModel {
    batch_id: number = 0;
    studentIds: number[] = []
    group_name: string = null;
    // group_id: number = null;

}